module.exports = __webpack_public_path__ + "static/cloud-atlas-9cf3f740c02096517e539e877109ae36.jpg";